import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=acb8ece2&scoped=true&lang=pug&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=acb8ece2&prod&lang=sass&scoped=true&"
import style1 from "./AdminSettings.vue?vue&type=style&index=1&id=acb8ece2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb8ece2",
  null
  
)

export default component.exports